import { SubscriptionDetails } from "./subscription-details";

export class Subscription {
	constructor(subscription) {
		this.current = subscription.current
			? new SubscriptionDetails(subscription.current)
			: null;
		this.next = subscription.next
			? new SubscriptionDetails(subscription.next)
			: null;
		this.startDate = subscription.startDate;
		this.endDate = this.current?.endDate;
		this.isExpired = subscription.isExpired;
		this.isRenewed = subscription.isRenewed;
		this.isLegacy = subscription.isLegacy;
	}

	get formattedStartDate() {
		return this._formatDate(this.startDate);
	}

	get formattedEndDate() {
		return this._formatDate(this.endDate);
	}

	get qttAddons() {
		return this.current?.ratePlanDetails?.addons || null;
	}

	get extensionsNumber() {
		return (
			this.current?.extensions?.reduce((acc, { type, quantity }) => {
				const numberOfPoint = parseInt(type.split("_")[1], 10);
				return acc + numberOfPoint * quantity;
			}, 0) || null
		);
	}

	// @TODO: use $dayjs to format date
	_formatDate(date) {
		if (!date || date === null || date === undefined) {
			return null;
		}

		const pattern = /(\d{4})-(\d{2})-(\d{2})/;
		if (!date || !pattern.test(date)) {
			return null;
		}
		return date.replace(pattern, "$3/$2/$1");
	}
}
